import * as React from 'react';

import BaseInsightsPage from 'modules/insights/pages/BaseInsightsPage';

import SOVReportPageCollabaryInstagram from './instagram/SOVReportPageCollabaryInstagram';
import SOVReportPageCollabaryYoutube from './youtube/SOVReportPageCollabaryYoutube';

import { __t, applyTranslations } from 'utils/language';
import { YOUTUBE } from 'modules/insights/sov/utils/sov';

import type { LineGraphEChartsObject, LocationWindow, Organization } from 'types';
import type {
  SOVGeneralVoidFunction,
  SOVReport,
  SOVReportType,
  SOVReportUpdateCallback
} from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('modules/insights/sov/shared/sov-shared.i18n.json'));

type Props = {
  organization: Organization,
  location: LocationWindow,
  brandProfileId: number | undefined | null,
  report: SOVReport,
  reportId: number,
  reportType: SOVReportType,
  isReportSaved: boolean,
  graphInstance: LineGraphEChartsObject | undefined | null,
  isAnalysisDownloading: boolean,
  sovTimeframeCanSelectPastTwoWeeks: boolean,
  onRenderBreadcrumbs: () => React.ReactNode,
  onRenderPageHeader: () => React.ReactNode,
  onRenderReportHeader: (onUpdateReport: SOVReportUpdateCallback, onDownloadReport?: SOVGeneralVoidFunction | null) => React.ReactNode,
  onReportSavedText: () => void,
  onChartInstanceCallback: (echartsInstance: LineGraphEChartsObject) => void
};

const SHARED_MSG_KEY = 'sov_shared';

class SOVReportPageCollabary extends React.PureComponent<Props> {
  getDocumentTitle(): string {
    return `${__t(`${SHARED_MSG_KEY}.labels.share_of_voice`)}`;
  }

  renderYoutube(): React.ReactNode {
    const {
      location,
      brandProfileId,
      report,
      reportId,
      reportType,
      isReportSaved,
      sovTimeframeCanSelectPastTwoWeeks,
      onRenderBreadcrumbs,
      onRenderPageHeader,
      onRenderReportHeader,
      onReportSavedText,
      onChartInstanceCallback
    } = this.props;

    return (
      <SOVReportPageCollabaryYoutube
        location={location}
        brandProfileId={brandProfileId}
        report={report}
        reportId={reportId}
        reportType={reportType}
        isReportSaved={isReportSaved}
        sovTimeframeCanSelectPastTwoWeeks={sovTimeframeCanSelectPastTwoWeeks}
        onRenderBreadcrumbs={onRenderBreadcrumbs}
        onRenderPageHeader={onRenderPageHeader}
        onRenderReportHeader={onRenderReportHeader}
        onReportSavedText={onReportSavedText}
        onChartInstanceCallback={onChartInstanceCallback}
      />
    );
  }

  renderInstagram(): React.ReactNode {
    const {
      organization,
      location,
      brandProfileId,
      report,
      reportId,
      reportType,
      isReportSaved,
      isAnalysisDownloading,
      graphInstance,
      sovTimeframeCanSelectPastTwoWeeks,
      onRenderBreadcrumbs,
      onRenderPageHeader,
      onRenderReportHeader,
      onReportSavedText,
      onChartInstanceCallback
    } = this.props;

    return (
      <SOVReportPageCollabaryInstagram
        organization={organization}
        location={location}
        brandProfileId={brandProfileId}
        report={report}
        reportId={reportId}
        reportType={reportType}
        isReportSaved={isReportSaved}
        isAnalysisDownloading={isAnalysisDownloading}
        graphInstance={graphInstance}
        sovTimeframeCanSelectPastTwoWeeks={sovTimeframeCanSelectPastTwoWeeks}
        onRenderBreadcrumbs={onRenderBreadcrumbs}
        onRenderPageHeader={onRenderPageHeader}
        onRenderReportHeader={onRenderReportHeader}
        onReportSavedText={onReportSavedText}
        onChartInstanceCallback={onChartInstanceCallback}
      />
    );
  }

  render(): React.ReactNode {
    const { organization, reportType } = this.props;

    return (
      <BaseInsightsPage
        documentTitle={this.getDocumentTitle()}
        organization={organization}
      >
        <div className="sov-report-page sov-report-page-collabary">
          {
            reportType === YOUTUBE
              ? this.renderYoutube()
              : this.renderInstagram()
          }
        </div>
      </BaseInsightsPage>
    );
  }
}

export default SOVReportPageCollabary;
